export interface IW30 {
  // PCP / practice
  tin?: string | null;
  plan?: string | null;
  practice_name?: string | null;
  npi?: string | null;
  pcp_name?: string | null;
  pcp_address?: string | null;
  pcp_city?: string | null;
  pcp_state?: string | null;
  pcp_zip?: string | null;

  // Measure
  measure_code?: string | null;
  measure_description?: string | null;
  denominator?: string | null;
  numerator?: string | null;
  line_of_business?: string | null;

  // Member
  plan_member_id?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  date_of_birth?: string | null;
  language?: string | null;
  race_ethnicity?: string | null;
  gender?: string | null;
  member_address?: string | null;
  member_city?: string | null;
  member_state?: string | null;
  member_zip?: string | null;
  member_phone?: string | null;
  member_emr_phone_number?: string | null;

  // W30 milestones / visits
  month_15_as_of?: string | null;
  month_30_as_of?: string | null;
  visit_1?: string | null;
  visit_2?: string | null;
  visit_3?: string | null;
  visit_4?: string | null;
  visit_5?: string | null;
  visit_6?: string | null;
  visit_7?: string | null;
  visit_8?: string | null;
  total_visits?: string | null;

  // Reporting / metadata
  daterun?: string | null;
  filename?: string | null;
  added_tz?: string | null;
  file_date?: string | null;
  somos_member_id?: string | null;
  somos_provider_id?: string | null;
  service_location_id?: string | null;
  reporting_period?: string | null;
  owner_id?: number | null;
}

export class W30 implements IW30 {
  tin?: string | null;
  plan?: string | null;
  practice_name?: string | null;
  npi?: string | null;
  pcp_name?: string | null;
  pcp_address?: string | null;
  pcp_city?: string | null;
  pcp_state?: string | null;
  pcp_zip?: string | null;

  measure_code?: string | null;
  measure_description?: string | null;
  denominator?: string | null;
  numerator?: string | null;
  line_of_business?: string | null;

  plan_member_id?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  date_of_birth?: string | null;
  language?: string | null;
  race_ethnicity?: string | null;
  gender?: string | null;
  member_address?: string | null;
  member_city?: string | null;
  member_state?: string | null;
  member_zip?: string | null;
  member_phone?: string | null;
  member_emr_phone_number?: string | null;

  month_15_as_of?: string | null;
  month_30_as_of?: string | null;
  visit_1?: string | null;
  visit_2?: string | null;
  visit_3?: string | null;
  visit_4?: string | null;
  visit_5?: string | null;
  visit_6?: string | null;
  visit_7?: string | null;
  visit_8?: string | null;
  total_visits?: string | null;

  daterun?: string | null;
  filename?: string | null;
  added_tz?: string | null;
  file_date?: string | null;
  somos_member_id?: string | null;
  somos_provider_id?: string | null;
  service_location_id?: string | null;
  reporting_period?: string | null;
  owner_id?: number | null;

  constructor(data: IW30) {
    Object.assign(this, data);
  }

  static fromObject(data: IW30): W30 {
    return new W30(data);
  }

  static fromObjectArray(data: IW30[]): W30[] {
    return data.map(W30.fromObject);
  }
}

export interface IResultW30 {
  count: number;
  next: string | null;
  previous: string | null;
  results: IW30[];
}

export class ResultW30 implements IResultW30 {
  count: number = 0;
  next: string | null = null;
  previous: string | null = null;
  results: W30[] = [];

  constructor(data?: IResultW30) {
    if (data) {
      this.count = data.count;
      this.next = data.next;
      this.previous = data.previous;
      this.results = data.results ? W30.fromObjectArray(data.results) : [];
    }
  }

  static fromObject(data: IResultW30): ResultW30 {
    return new ResultW30(data);
  }
}
